import React from 'react'
import { useField } from 'formik'

interface SelectOption {
  value: string
  label: string
}

interface GroupSelectProps {
  name: string
  label?: string
  labelPosition?: 'top' | 'left'
  options: readonly SelectOption[]
  wrapperClassName?: string
  disabled?: boolean
}

const GroupSelect: React.FC<GroupSelectProps> = ({
  name,
  label,
  labelPosition = 'top',
  options,
  wrapperClassName = '',
  disabled = false,
}) => {
  const [field, meta, helpers] = useField<string[]>({
    name,
  })

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValues = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    )

    helpers.setValue(selectedValues)
  }

  const renderLabel = () => {
    if (!label) return null

    return (
      <label className={`form-label fw-bold ${labelPosition === 'left' ? 'mb-0' : ''}`}>
        {label}
      </label>
    )
  }

  const selectElement = (
    <div
      className={`${
        labelPosition === 'left' && label ? 'flex-grow-1' : 'w-100'
      } min-w-0`}
    >
      <select
        {...field}
        multiple
        className={`group-select ${
          meta.touched && meta.error ? 'is-invalid' : ''
        }`}
        value={field.value || []}
        disabled={disabled}
        onChange={handleChange}
        onBlur={() => helpers.setTouched(true)}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {meta.touched && meta.error && (
        <div className="error-text">{meta.error}</div>
      )}
    </div>
  )

  if (labelPosition === 'left' && label) {
    return (
      <div className={`${wrapperClassName} h-100 w-100 min-w-0`}>
        <div className='d-flex align-items-start gap-3 h-100 w-100 min-w-0'>
          <div className='flex-shrink-0 pt-2'>
            {renderLabel()}
          </div>
          {selectElement}
        </div>
      </div>
    )
  }

  return (
    <div className={`${wrapperClassName} h-100 w-100 min-w-0`}>
      {renderLabel()}
      {selectElement}
    </div>
  )
}

export default GroupSelect